module.exports = __webpack_public_path__ + "img/rota99.ab510918.webp";